import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.parse-int.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Restaurant = /*#__PURE__*/function () {
  function Restaurant(config, axios, common) {
    _classCallCheck(this, Restaurant);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "common", void 0);

    this.axios = axios;
    this.config = config;
    this.common = common;
  }

  _createClass(Restaurant, [{
    key: "getRestaurantDetailsById",
    value: function () {
      var _getRestaurantDetailsById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restaurantId) {
        var _response$data, _response$data$succes;

        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get(this.config.postfix.RESTAURANT_DETAILS, {
                  params: {
                    restaurantId: restaurantId
                  }
                });

              case 2:
                response = _context.sent;
                return _context.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$succes = _response$data.successResponse) === null || _response$data$succes === void 0 ? void 0 : _response$data$succes.restaurantDetails);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRestaurantDetailsById(_x) {
        return _getRestaurantDetailsById.apply(this, arguments);
      }

      return getRestaurantDetailsById;
    }()
  }, {
    key: "getRestaurantDetailsByNumber",
    value: function () {
      var _getRestaurantDetailsByNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(restaurantNumber) {
        var _response$data2, _response$data2$succe;

        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.axios.get(this.config.postfix.CURBSIDE_RESTAURANT_NUMBER_API, {
                  params: {
                    restaurantNumber: restaurantNumber,
                    restNumFlag: true
                  }
                });

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$succe = _response$data2.successResponse) === null || _response$data2$succe === void 0 ? void 0 : _response$data2$succe.restaurantDetails);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRestaurantDetailsByNumber(_x2) {
        return _getRestaurantDetailsByNumber.apply(this, arguments);
      }

      return getRestaurantDetailsByNumber;
    }()
  }, {
    key: "getAllRestaurants",
    value: function () {
      var _getAllRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(conceptCode) {
        var _resp$data, _resp$data$successRes;

        var commonQueryParams, locale, resp;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context3.next = 4;
                return this.axios.post(this.config.postfix.SEARCH_RESTAURANT, {
                  geoCode: "44.6709,-103.8514",
                  resultsPerPage: "1000",
                  resultsOffset: "0",
                  locale: locale,
                  conceptCode: conceptCode
                }, {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "x-retry-on-timeout": true
                  },
                  transformRequest: [function (obj) {
                    var str = [];

                    for (var p in obj) {
                      if (obj[p]) {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                      }
                    }

                    return str.join("&");
                  }]
                });

              case 4:
                resp = _context3.sent;

                if ((_resp$data = resp.data) !== null && _resp$data !== void 0 && (_resp$data$successRes = _resp$data.successResponse) !== null && _resp$data$successRes !== void 0 && _resp$data$successRes.locationSearchResult) {
                  resp.data.successResponse.locationSearchResult.Location = this.common.processRestaurantDetails(resp.data.successResponse.locationSearchResult.Location);
                }

                return _context3.abrupt("return", resp.data);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAllRestaurants(_x3) {
        return _getAllRestaurants.apply(this, arguments);
      }

      return getAllRestaurants;
    }()
  }, {
    key: "searchRestaurants",
    value: function () {
      var _searchRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(lat, _long) {
        var _data$successResponse, _data$successResponse2;

        var offset,
            pageSize,
            opts,
            commonQueryParams,
            locale,
            resp,
            data,
            _data$successResponse3,
            currTimeStamp,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                offset = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 0;
                pageSize = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : 5;
                opts = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : {
                  pdEnabled: false,
                  isToGo: false,
                  reservationEnabled: false,
                  privateDiningEnabled: false,
                  isNew: false,
                  displayDistance: true
                };
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context4.next = 7;
                return this.axios.post(this.config.postfix.SEARCH_RESTAURANT, _objectSpread(_objectSpread({
                  geoCode: "".concat(lat, ",").concat(_long),
                  resultsPerPage: pageSize,
                  resultsOffset: offset
                }, opts), {}, {
                  locale: locale
                }), {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "x-retry-on-timeout": true
                  },
                  transformRequest: [function (obj) {
                    var str = [];

                    for (var p in obj) {
                      if (obj[p]) {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                      }
                    }

                    return str.join("&");
                  }]
                });

              case 7:
                resp = _context4.sent;
                data = resp.data;

                if (data !== null && data !== void 0 && (_data$successResponse = data.successResponse) !== null && _data$successResponse !== void 0 && (_data$successResponse2 = _data$successResponse.locationSearchResult) !== null && _data$successResponse2 !== void 0 && _data$successResponse2.Location) {
                  currTimeStamp = Date.now();
                  data.successResponse.locationSearchResult.Location = (_data$successResponse3 = data.successResponse.locationSearchResult.Location) === null || _data$successResponse3 === void 0 ? void 0 : _data$successResponse3.map(function (loc) {
                    return _objectSpread(_objectSpread({}, loc), {}, {
                      timeAtResponse: currTimeStamp
                    });
                  });
                  data.successResponse.locationSearchResult.Location = this.common.processRestaurantDetails(data.successResponse.locationSearchResult.Location);
                }

                return _context4.abrupt("return", data);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function searchRestaurants(_x4, _x5) {
        return _searchRestaurants.apply(this, arguments);
      }

      return searchRestaurants;
    }()
  }, {
    key: "restaurantStatus",
    value: function restaurantStatus(restaurant, showFullStatus) {
      var _restaurant$waitListI;

      if (restaurant !== null && restaurant !== void 0 && restaurant.webAhead && restaurant !== null && restaurant !== void 0 && (_restaurant$waitListI = restaurant.waitListInformation) !== null && _restaurant$waitListI !== void 0 && _restaurant$waitListI.isAvailable) {
        var _restaurant$waitListI2, _restaurant$waitListI3;

        if (restaurant !== null && restaurant !== void 0 && restaurant.isClosed) {
          return "Waitlist Closed.";
        }

        if (!!(restaurant !== null && restaurant !== void 0 && (_restaurant$waitListI2 = restaurant.waitListInformation) !== null && _restaurant$waitListI2 !== void 0 && _restaurant$waitListI2.lowQuote) && !!(restaurant !== null && restaurant !== void 0 && (_restaurant$waitListI3 = restaurant.waitListInformation) !== null && _restaurant$waitListI3 !== void 0 && _restaurant$waitListI3.highQuote)) {
          var _restaurant$waitListI4;

          if (+(restaurant === null || restaurant === void 0 ? void 0 : (_restaurant$waitListI4 = restaurant.waitListInformation) === null || _restaurant$waitListI4 === void 0 ? void 0 : _restaurant$waitListI4.highQuote) === 0) {
            if (showFullStatus) {
              return "No Wait currently";
            }

            return "No Wait";
          } // else if (restaurant?.waitListInformation?.highQuote > 60) {
          //   if (showFullStatus) {
          //     return "Est. Wait Time: 1+ hr";
          //   }
          //   return "Est. wait  1+ hr";
          // }
          // if (showFullStatus) {
          //   return `Est. Wait Time: ${restaurant?.waitListInformation?.lowQuote} - ${restaurant?.waitListInformation?.highQuote} mins`;
          // }


          return "Waitlist Available"; // `Est. wait ${restaurant?.waitListInformation?.lowQuote} - ${restaurant?.waitListInformation?.highQuote} mins`;
        }

        return "Wait Time Unavailable";
      } else {
        var _restaurant$waitListI5;

        if (!(restaurant !== null && restaurant !== void 0 && restaurant.webAhead)) {
          return "Waitlist Not Supported";
        } else if (!(restaurant !== null && restaurant !== void 0 && (_restaurant$waitListI5 = restaurant.waitListInformation) !== null && _restaurant$waitListI5 !== void 0 && _restaurant$waitListI5.isAvailable)) {
          return "Waitlist Closed";
        }

        return "Waitlist Not Supported";
      }
    }
  }, {
    key: "getRestaurantByIds",
    value: function () {
      var _getRestaurantByIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(locations) {
        var _data$successResponse4, _data$successResponse5, _data$successResponse6;

        var resp, data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.axios.post(this.config.postfix.LIST_LOCATIONS, {
                  locationIds: locations
                }, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 2:
                resp = _context5.sent;
                data = resp.data;

                if (data !== null && data !== void 0 && (_data$successResponse4 = data.successResponse) !== null && _data$successResponse4 !== void 0 && _data$successResponse4.locationSearchResult) {
                  data.successResponse.locationSearchResult.Location = this.common.processRestaurantDetails(data.successResponse.locationSearchResult.Location);
                }

                return _context5.abrupt("return", data === null || data === void 0 ? void 0 : (_data$successResponse5 = data.successResponse) === null || _data$successResponse5 === void 0 ? void 0 : (_data$successResponse6 = _data$successResponse5.locationSearchResult) === null || _data$successResponse6 === void 0 ? void 0 : _data$successResponse6.Location);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getRestaurantByIds(_x6) {
        return _getRestaurantByIds.apply(this, arguments);
      }

      return getRestaurantByIds;
    }()
  }, {
    key: "checkCarsideAvailable",
    value: function () {
      var _checkCarsideAvailable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _response$data3, _response$data3$succe;

        var response, data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.axios.post(this.config.postfix.CHECK_CARSIDE_AVAIL, null, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 2:
                response = _context6.sent;
                data = response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$succe = _response$data3.successResponse) === null || _response$data3$succe === void 0 ? void 0 : _response$data3$succe.curbSideAvailable;
                return _context6.abrupt("return", data && data === "true" ? true : false);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function checkCarsideAvailable() {
        return _checkCarsideAvailable.apply(this, arguments);
      }

      return checkCarsideAvailable;
    }()
  }, {
    key: "updateLocation",
    value: function () {
      var _updateLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(restaurantId, restaurantNum) {
        var viewMenuOnly,
            asapSelected,
            validateCartItems,
            data,
            response,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                viewMenuOnly = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : false;
                asapSelected = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : false;
                validateCartItems = _args7.length > 4 && _args7[4] !== undefined ? _args7[4] : false;
                data = {
                  validateCartItems: validateCartItems,
                  restaurantId: restaurantId,
                  restaurantNum: restaurantNum,
                  viewMenuOnly: viewMenuOnly,
                  togoNewFlow: "true",
                  asapSelected: asapSelected,
                  locale: "en_US"
                };
                _context7.next = 6;
                return this.axios.post(this.config.postfix.UPDATE_LOCATION, data, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 6:
                response = _context7.sent;
                return _context7.abrupt("return", response.data);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateLocation(_x7, _x8) {
        return _updateLocation.apply(this, arguments);
      }

      return updateLocation;
    }()
  }, {
    key: "getRestaurantPDFMenuURL",
    value: function () {
      var _getRestaurantPDFMenuURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(restaurantNumber) {
        var _response$data4, response;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.axios.get(this.config.postfix.RESTAURANT_PDF_CONF);

              case 3:
                response = _context8.sent;
                return _context8.abrupt("return", this._processRestaurantPDFMenu(response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.pdfMenuConfig, restaurantNumber));

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", null);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 7]]);
      }));

      function getRestaurantPDFMenuURL(_x9) {
        return _getRestaurantPDFMenuURL.apply(this, arguments);
      }

      return getRestaurantPDFMenuURL;
    }()
  }, {
    key: "getDeliveryRestaurants",
    value: function () {
      var _getDeliveryRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(geoCode, searchText) {
        var data, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                data = {
                  geoCode: geoCode,
                  resultsPerPage: "70",
                  searchText: searchText,
                  locale: "en_US"
                };
                _context9.next = 3;
                return this.axios.post(this.config.postfix.GET_DELIVERY_RESTAURANTS, data, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 3:
                response = _context9.sent;
                return _context9.abrupt("return", response.data.successResponse.locationSearchResult);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getDeliveryRestaurants(_x10, _x11) {
        return _getDeliveryRestaurants.apply(this, arguments);
      }

      return getDeliveryRestaurants;
    }()
  }, {
    key: "setDeliveryAddress",
    value: function () {
      var _setDeliveryAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref) {
        var addressLine1, addressLine2, city, companyName, country, state, type, zipcode, data, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                addressLine1 = _ref.addressLine1, addressLine2 = _ref.addressLine2, city = _ref.city, companyName = _ref.companyName, country = _ref.country, state = _ref.state, type = _ref.type, zipcode = _ref.zipcode;
                data = {
                  ignoreAddressValidation: false,
                  deliveryAddress: {
                    "atg-rest-class-type": "java.util.HashMap",
                    "atg-rest-values": {
                      addressLine1: addressLine1,
                      city: city,
                      state: state,
                      zipcode: zipcode,
                      country: country,
                      type: type,
                      addressLine2: addressLine2,
                      companyName: companyName
                    }
                  }
                };
                _context10.next = 4;
                return this.axios.post(this.config.postfix.SET_DELIVERY_ADDRESS, data, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 4:
                response = _context10.sent;
                return _context10.abrupt("return", response.data);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setDeliveryAddress(_x12) {
        return _setDeliveryAddress.apply(this, arguments);
      }

      return setDeliveryAddress;
    }()
  }, {
    key: "setDeliveryTime",
    value: function () {
      var _setDeliveryTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(restaurantId, deliveryDate, deliveryTime, partySize, deliveryRestDuration, deliveryRestDistance) {
        var data, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                data = {
                  deliveryDate: deliveryDate,
                  deliveryTime: deliveryTime,
                  restaurantId: restaurantId,
                  togoMenuFlow: "true",
                  partySize: partySize,
                  deliveryRestDuration: deliveryRestDuration,
                  deliveryRestDistance: deliveryRestDistance,
                  isAddAddressFlow: true
                };
                _context11.next = 3;
                return this.axios.post(this.config.postfix.SET_DELIVERY_TIME, data, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 3:
                response = _context11.sent;
                return _context11.abrupt("return", response.data.status);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setDeliveryTime(_x13, _x14, _x15, _x16, _x17, _x18) {
        return _setDeliveryTime.apply(this, arguments);
      }

      return setDeliveryTime;
    }()
  }, {
    key: "getTargetersForCurrentRestaurant",
    value: function () {
      var _getTargetersForCurrentRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(targeterPath, restNumber, conceptCode, channel) {
        var _response$data5;

        var response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.axios.get(this.config.postfix.GET_TARGETERS, {
                  params: {
                    targeterPath: targeterPath,
                    restNumber: restNumber,
                    conceptCode: conceptCode,
                    channel: channel
                  }
                });

              case 2:
                response = _context12.sent;
                return _context12.abrupt("return", (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.successresponse);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getTargetersForCurrentRestaurant(_x19, _x20, _x21, _x22) {
        return _getTargetersForCurrentRestaurant.apply(this, arguments);
      }

      return getTargetersForCurrentRestaurant;
    }()
  }, {
    key: "_processRestaurantPDFMenu",
    value: function _processRestaurantPDFMenu(pdfMenuConfig, restaurantNum) {
      var locationArr = pdfMenuConfig === null || pdfMenuConfig === void 0 ? void 0 : pdfMenuConfig.locationEnabled;
      var restMenuConfig = pdfMenuConfig === null || pdfMenuConfig === void 0 ? void 0 : pdfMenuConfig.restMenuConfig;
      var pdfMenuUrl = "";
      var isPdfMenuEnabled;

      if (restaurantNum && locationArr && restMenuConfig && locationArr.includes(parseInt(restaurantNum))) {
        if (pdfMenuConfig !== null && pdfMenuConfig !== void 0 && pdfMenuConfig.isSingleMenu) {
          var restautantFound = restMenuConfig.filter(function (item) {
            return item.locationNum === parseInt(restaurantNum);
          });

          if (restautantFound.length > 0) {
            pdfMenuUrl = (pdfMenuConfig === null || pdfMenuConfig === void 0 ? void 0 : pdfMenuConfig.staticURL) + restautantFound[0].fileName;
            isPdfMenuEnabled = true;
          } else {
            isPdfMenuEnabled = false;
          }
        } else {
          isPdfMenuEnabled = true;
          pdfMenuUrl = (pdfMenuConfig === null || pdfMenuConfig === void 0 ? void 0 : pdfMenuConfig.multiMenuLandingPage) + restaurantNum;
        }
      } else {
        isPdfMenuEnabled = false;
      }

      if (isPdfMenuEnabled) {
        return pdfMenuUrl;
      }

      return null;
    }
  }]);

  return Restaurant;
}();

export { Restaurant as default };